import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=e6cbe504&scoped=true&"
import script from "./ResetForm.vue?vue&type=script&lang=ts&"
export * from "./ResetForm.vue?vue&type=script&lang=ts&"
import style0 from "./ResetForm.vue?vue&type=style&index=0&id=e6cbe504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cbe504",
  null
  
)

export default component.exports